<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12">
    <label class="label-large-bold">Sub - Task type</label>
    <div>
      <p>I-130</p>
    </div>
  </div>
</div>
<div class="p-grid dashed-line p-my-4"></div>
<div [formGroup]="petitionTaskForm">
  <!-- <div class="p-fluid p-formgrid p-grid">
    <div class="p-col-4">
      <label class="create-task-label required">Select Applicant</label>
      <p-dropdown [options]="dependentList" formControlName="familyId" name="familyId" optionLabel="displayName"
        optionValue="id" placeholder="Select Applicant">
      </p-dropdown>
    </div>
    <div class="p-col-8 align-self-end">
      <label class="create-task-label d-block mb-0">Dependents not added in beneficiary profile?</label>
      <span><a class="dependant-not-available-actions" (click)="notifyBeneficiary()">Notify Beneficiary</a> or <a
          class="dependant-not-available-actions" (click)="visitBeneficiaryProfile()">Visit Profile</a></span>
    </div>
    <div class="p-col-4">
      <small class="p-error" *ngIf="dependentList && dependentList.length === 0">
        No Dependents Added.
      </small>
      <span class="invalid-message" *ngIf="dependentList && dependentList.length > 0 && petitionTaskForm.get('familyId').touched
        && petitionTaskForm.get('familyId').errors?.required">
        {{ getGlobalErrorMessages("REQUIRED") }}
      </span>
    </div>
  </div> -->
  <!-- <div class="p-grid dashed-line p-my-4"></div> -->
  <!-- <div class="p-fluid p-formgrid p-grid">
    <div class="p-col-4">
      <label class="create-task-label required">Petition Preparing</label>
      <div class="p-formgroup-inline">
        <div class="p-field-checkbox">
          <p-radioButton name="filingType" value="standard" formControlName="filingType"
            inputId="standard"></p-radioButton>
          <label for="standard" class="create-task-label">Standard</label>
        </div>
        <div class="p-field-checkbox">
          <p-radioButton name="filingType" value="e-filing" formControlName="filingType"
            inputId="e-filing"></p-radioButton>
          <label for="e-filing" class="create-task-label">E-filing</label>
        </div>
      </div>

    </div>
  </div>
  <div class="p-grid dashed-line p-my-4"></div> -->
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-col-4">
      <label class="create-task-label required">Select processing type</label>
      <div class="p-formgroup-inline">
        <div class="p-field-checkbox">
          <p-radioButton name="processingType" [disabled]="true" value="regular" (onClick)="onChangeProcessingType()"
            formControlName="processingType" inputId="regular" class="disabled"></p-radioButton>
          <label for="regular" class="create-task-label disabled">Regular</label>
        </div>
        <div class="p-field-checkbox">
          <p-radioButton name="processingType" [disabled]="true" value="premium" (onClick)="onChangeProcessingType()"
            formControlName="processingType" inputId="premium" class="disabled"></p-radioButton>
          <label for="premium" class="create-task-label disabled">Premium</label>
        </div>
      </div>
      <span class="invalid-message"
        *ngIf="petitionTaskForm.get('processingType').touched && petitionTaskForm.get('processingType').errors?.required">
        {{ getGlobalErrorMessages("REQUIRED") }}
      </span>
    </div>

    <div class="p-col-4">
      <label class="create-task-label required">Select Service Center</label>
      <p-dropdown [options]="serviceCenters" formControlName="serviceCenterId" name="serviceCenterId" optionLabel="name"
        optionValue="id" placeholder="Select Service center">
      </p-dropdown>
      <span class="invalid-message"
        *ngIf="petitionTaskForm.get('serviceCenterId').touched && petitionTaskForm.get('serviceCenterId').errors?.required">
        {{ getGlobalErrorMessages("REQUIRED") }}
      </span>
    </div>
  </div>
  <div class="p-grid dashed-line p-my-4"></div>


  <div>
    <h5 class="labelText">Lawfirm Details </h5>
    <div class="p-grid">
      <div class="p-col-4 pl-0">
        <label class="mt-2 ml-2 create-task-label label-cls">Firm Name</label>
        <div class="row mt-1 ml-2">
          {{employeeDetails?.companyName}}
        </div>
      </div>
      <div class="p-col-4">
        <label class="mt-2 ml-2 create-task-label label-cls">Preparer Name</label>
        <div class="row mt-1 ml-2">
          {{employeeDetails?.firstName ? employeeDetails?.firstName +' '+employeeDetails?.lastName : '--'}}
        </div>
      </div>
    </div>
  </div>
  <div class="p-grid dashed-line p-my-4"></div>
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-col-4">
      <label class="create-task-label required">Petitioner Preparer Name</label>
      <p-dropdown [options]="users" formControlName="immSpecialistId" name="immSpecialistId" optionLabel="firstName"
        optionValue="id" placeholder="Select Petitioner Preparer" (onChange)="onPetitionerPreparerSelected()"
        appendTo="body">
        <ng-template pTemplate="selectedItem">
          <div *ngIf="selectedPetitionPreparer">
            <div>{{selectedPetitionPreparer?.firstName ? selectedPetitionPreparer?.firstName +'
              '+selectedPetitionPreparer?.lastName : '--'}}</div>
          </div>
        </ng-template>
        <ng-template let-employee pTemplate="item">
          <div>
            <div>{{employee?.firstName +' '+employee?.lastName}}</div>
          </div>
        </ng-template>
      </p-dropdown>
      <span class="invalid-message"
        *ngIf="petitionTaskForm.get('immSpecialistId').touched && petitionTaskForm.get('immSpecialistId').errors?.required">
        {{ getGlobalErrorMessages("REQUIRED") }}
      </span>
    </div>
  </div>
</div>